import { render, staticRenderFns } from "./SignDocuments.vue?vue&type=template&id=f3f925fe&scoped=true"
import script from "./SignDocuments.vue?vue&type=script&lang=js"
export * from "./SignDocuments.vue?vue&type=script&lang=js"
import style0 from "./SignDocuments.vue?vue&type=style&index=0&id=f3f925fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f925fe",
  null
  
)

export default component.exports